"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Details/SenderPicker/SenderItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _peers = require('shared/selectors/peers');


var _entities = require('shared/transforms/entities');
var _hooks = require('web/services/hooks');

var _Avatar = require('web/components/Avatar');
var _Form = require('web/components/Form');






const SenderAvatar = ({ option, ...props }) => (
  _react2.default.createElement(_Avatar.UserAvatar, { userKey: option, ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}} )
)

const SenderItem = props => {
  const { option, orgKey } = props
  const user = _hooks.useAppSelector.call(void 0, state => option && _peers.selectUserByKey.call(void 0, state, option))
  const userEntity = _react.useMemo.call(void 0, 
    () => user
      ? _entities.mapUserToEntity.call(void 0, {}, _entities.makeSpecificOrgTitleUserDescription.call(void 0, orgKey))(user)
      : null,
    [user, orgKey],
  )

  if (!userEntity && props.isPreviewOption) {
    return (
      _react2.default.createElement(_Form.GenericEntityOption, { isEmpty: true, onSelect: props.onSelect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, "Pick a sender"

      )
    )
  }

  if (!userEntity) return null

  return (
    _react2.default.createElement(_Form.GenericEntityOption, {
      Avatar: SenderAvatar,
      name: userEntity.name,
      description: userEntity.description,
      ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
    )
  )
}

exports. default = _react.memo.call(void 0, SenderItem)
